import { render, staticRenderFns } from "./HKLII2023.vue?vue&type=template&id=e8314962&scoped=true"
import script from "./HKLII2023.vue?vue&type=script&lang=js"
export * from "./HKLII2023.vue?vue&type=script&lang=js"
import style0 from "./HKLII2023.vue?vue&type=style&index=0&id=e8314962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8314962",
  null
  
)

export default component.exports